import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { api } from '../../api/client';
import { useToast } from '../../context/ToastContext';
import '../../App.css';
import EventTemplateForm, { IEventTemplateFormData } from '../../components/forms/EventTemplateForm';
import { translateError } from '../../utils/errorMessages';

const EventTemplateCreatePage: React.FC = () => {
  const { t } = useTranslation();
  const { addToast } = useToast();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (data: IEventTemplateFormData) => {
    setLoading(true);
    setError(null);

    try {
      const response = await api.eventTemplates.create({
        name: data.name,
        description: data.description,
        location: data.location,
        firstOccurrence: new Date(data.firstOccurrence + 'T12:00:00').toISOString(),
        endsOn: data.endsOn ? data.endsOn : null,
        startTime: data.startTime,
        endTime: data.endTime,
        recurringPattern: data.recurringPattern,
        defaultAttendance: data.defaultAttendance,
        members: data.members,
        groups: data.groups,
        coveredByMembershipIds: data.coveredByMembershipIds,
        followers: data.followers,
        responsible: data.responsible,
        activityId: data.activityId ? Number(data.activityId) : null,
        courseId: data.courseId,
      });

      setLoading(false);
      addToast(t('templates.createdAlert', { count: (response.data as { eventsGenerated: number }).eventsGenerated }), 'success');
      navigate('/admin/event-templates');
    } catch (err: any) {
      const errorMessage = translateError(err, t);
      setError(errorMessage);
      addToast(t('common.error') + ': ' + errorMessage, 'error');
      setLoading(false);
    }
  };

  return (
    <div className="admin-form-page">
      <h2>{t('templates.createTitle')}</h2>
      {error && <p className="error-message">{t('common.error')}: {error}</p>}
      <EventTemplateForm
        onSubmit={handleSubmit}
        loading={loading}
        submitButtonText={t('templates.createButton')}
        seasonSeedHint
      />
      <Link to="/admin/event-templates" className="form-link">{t('templates.goBack')}</Link>
    </div>
  );
};

export default EventTemplateCreatePage;
